import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';
import { RENOLOG_LOCAL_API_REQUESTS } from './constants';

export const getSensorOrders = async (projectId) => {
  const apiPath = `projects/${projectId}/renolog/sensor-orders`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
    isLocalApiRequest: RENOLOG_LOCAL_API_REQUESTS,
  });

  const response = await axios(signedRequest);
  return response.data;
};
